import {EventEmitter, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map} from 'rxjs/internal/operators';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class I18nProvider {

  langUpdated: EventEmitter<string> = new EventEmitter();
  language: string;
  languageData: Array<any> = [];

  constructor(private http: HttpClient) {
    this.processLanguage();
  }

  processLanguage() {
    this.language = localStorage.getItem('selectedLanguage');
    if (!this.language || this.language.trim().length === 0) {
      this.setLanguage('en');
    } else {
      this.setLanguage(this.language.toLowerCase());
      if (this.language !== 'fr' && this.language !== 'nl' && this.language !== 'en') {
        this.setLanguage('en');
      }
    }
  }

  setLanguage(language: string) {
    this.language = language.toLowerCase();
    this.langUpdated.emit(this.language);
    localStorage.setItem('selectedLanguage', language);
  }

  load() {
    return new Promise((resolve) => {
      this.http.get(environment.baseUrl + '/i18n')
        .pipe(
          map((res: any) => {
            return res;
          }))
        .subscribe(value => {
          this.languageData = value;
          resolve(true);
        });
    });
  }

  getDescription(key: string): any {
    const langItems = this.languageData.find(langItem => {
      return (langItem.key === key.trim() && langItem.lang === this.language.trim());
    });
    if (langItems) {
      return langItems.value;
    }
    return '? i18n : ' + key + ' ?';
  }

}

export function i18nProviderFactory(provider: I18nProvider) {
  return () => {
    if (sessionStorage.getItem('DWP_TOKEN') === null) {
      provider.processLanguage(); // Use provider to call processLanguage
    } else {
      return provider.load();
    }
  };
}
